import { FvButton, Icon } from '@fv/client-components'
import type { FullShipment } from '@fv/client-types'

import { MiniQuoteList } from '@/features/mini-quote-list/MiniQuoteList'

import { DividedContent } from '../DividedContent'
import { DetailPanelLayout } from './DetailPanelLayout'

type QuoteHistoryPanelProps = {
  closePanel: () => void
  load: FullShipment
}

const QuoteHistoryPanel = ({ closePanel, load }: QuoteHistoryPanelProps) => {
  return (
    <DetailPanelLayout
      header={
        <DividedContent>
          <FvButton icon="arrow-to-left" onClick={closePanel}>
            Back
          </FvButton>
          <div>
            <Icon icon="list" className="text-fv-gray-dark" />
            <span>Quote history</span>
          </div>
        </DividedContent>
      }
    >
      <MiniQuoteList
        filter="active"
        readOnly
        load={load}
        canViewMessages={false}
      />
    </DetailPanelLayout>
  )
}

export default QuoteHistoryPanel
